import React, { useEffect, useState } from 'react';
import ConsultBanner from '../../components/ConsultBaneer';
import ConsultCard from '../../components/ConsultCard';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const Consult = () => {
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("consult");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return (
    <div>
      <Helmet>
        {/* ================= PRIMARY META ================= */}
        <title>
          {seoData.metaTitle || "Consult | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "DNA based nutrition consultation at Nutrillion"}
        />

        {seoData.metaKeywords && (
          <meta name="keywords" content={seoData.metaKeywords} />
        )}

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={
            seoData.canonicalUrl ||
            "https://nutrillion.one/consult"
          }
        />

        {/* ================= OPEN GRAPH ================= */}
        <meta property="og:type" content={seoData.ogType || "website"} />
        <meta property="og:title" content={seoData.ogTitle || seoData.metaTitle || "Consult | Nutrillion"} />
        <meta property="og:description" content={seoData.ogDescription || seoData.metaDescription || "DNA based nutrition consultation at Nutrillion"} />
        <meta property="og:url" content={seoData.ogUrl || seoData.canonicalUrl || "https://nutrillion.one/consult"} />
        {seoData.ogImage && (
          <meta property="og:image" content={seoData.ogImage} />
        )}
        <meta property="og:site_name" content="Nutrillion" />

        {/* ================= TWITTER CARD ================= */}
        <meta name="twitter:card" content={seoData.twitterCard || "summary"} />
        <meta name="twitter:title" content={seoData.twitterTitle || seoData.metaTitle || "Consult | Nutrillion"} />
        <meta name="twitter:description" content={seoData.twitterDescription || seoData.metaDescription || "DNA based nutrition consultation at Nutrillion"} />
        {(seoData.twitterImage || seoData.ogImage) && (
          <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />
        )}

        {/* ================= SCHEMA MARKUP ================= */}
       {seoData.schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(
              typeof seoData.schemaMarkup === "string"
                ? JSON.parse(seoData.schemaMarkup)
                : seoData.schemaMarkup
            )}
          </script>
        )}
      </Helmet>

      <ConsultBanner />
      <ConsultCard />
    </div>
  );
};

export default Consult;